// BullsEye: precision BTC price prediction game.
//
// Rounds are resolved by staked NFT nodes. Addresses come from the deploy (env()
// in .config.js: BULLS_EYE_ADDRESS, TOKEN_WBTC_ADDRESS), falling back to the old
// BSC testnet deployment. It uses the same USDT as the rest of Luckblocks
// plus WBTC for jackpots.
import { env, erc20Address } from '../../.config';

export const bullsEyeAddress =
  env('BULLS_EYE_ADDRESS', '0x7BC0Ce9C80296617DDbA68931BA0aAE51956670d');

export const usdtAddress = erc20Address;
export const wbtcAddress =
  env('TOKEN_WBTC_ADDRESS', '0xd3CcAd392A8f37B95d9a85327a9808735AcDBd0B');

/** Predictions are matched against a whole-dollar rounded BTC price. */
export const PRICE_DECIMALS = 8;
export const USDT_DECIMALS = 6;
export const WBTC_DECIMALS = 8;

/**
 * Prize tiers: index 0 is an exact hit (to the dollar), the others are bands of
 * distance from the final rounded price, in bps of that price. Each tier takes
 * a cut of the USDT pool, and an exact hit additionally takes the WBTC jackpot.
 * A tier with no winners rolls its share into the next round. The live values
 * come from the contract (getTierConfig); these are its defaults.
 */
const DEFAULT_TIER_BANDS_BPS = [0, 20, 40, 100, 200];
const DEFAULT_TIER_SHARES_BPS = [5000, 3000, 1000, 600, 400];

const percent = (bps) => `${Number((bps / 100).toFixed(2))}%`;

export const buildTiers = (bandsBps, sharesBps) =>
  bandsBps.map((bps, index) =>
    index === 0
      ? { margin: 0, bps: 0, labelKey: 'bullseye.tierExact', short: '0', share: sharesBps[0] / 100, jackpot: true }
      : {
          margin: index,
          bps,
          label: `≤${percent(bps)}`,
          short: `≤${percent(bps)}`,
          share: sharesBps[index] / 100,
          jackpot: false,
        }
  );

export const TIERS = buildTiers(DEFAULT_TIER_BANDS_BPS, DEFAULT_TIER_SHARES_BPS);

/** Referral commission unlocks by volume of people referred. */
export const REFERRAL_TIERS = [
  { min: 100, rate: 2, name: 'Tier 2' },
  { min: 50, rate: 1.75, name: 'Tier 1' },
  { min: 0, rate: 1.5, name: 'Tier 0' },
];

/** Monthly leaderboard pays the top three from the accumulated WBTC pool. */
export const MONTHLY_PRIZE_SPLIT = [50, 30, 20];

/** Leaderboard scoring, mirrored from the contract constants. */
export const SCORING = [
  { label: 'bullseye.scoreExact', points: 100 },
  { label: 'bullseye.scoreTier', suffix: ' (1 – 4)', points: 20 },
  { label: 'bullseye.scoreConsistency', points: 5 },
];

export { explorerTx, explorerAddress } from '../../utils';

/** Sections surfaced through ?section= , matching the Token/NFTnodes pattern. */
export const SECTIONS = ['game', 'winners', 'leaderboard', 'profile'];
